const constants = {
  COMPANIES_CHANGE_FILTER: 'COMPANIES_CHANGE_FILTER',
  COMPANIES_RESET_FILTER: 'COMPANIES_RESET_FILTER',
  COMPANIES_FETCH_START: 'COMPANIES_FETCH_START',
  COMPANIES_FETCH_END: 'COMPANIES_FETCH_END',
  COMPANIES_FETCH_FAILED: 'COMPANIES_FETCH_FAILED'
};

export default constants;
